import { queryClient } from "@/lib/queryClient";
import { SOURCE_OF_TRUTH_QUERY_KEY } from "@/hooks/useSourceOfTruth";
import { knowledgeBaseService } from "@/services/knowledgeBaseService";
import { userProfileService } from "@/services/userProfileService";

function parseMetadata(metadata: unknown): Record<string, unknown> {
  if (!metadata) return {};
  if (typeof metadata === "string") {
    try {
      return JSON.parse(metadata) as Record<string, unknown>;
    } catch {
      return {};
    }
  }
  if (typeof metadata === "object") return { ...(metadata as Record<string, unknown>) };
  return {};
}

export function readIsSourceOfTruthFromMetadata(metadata: unknown): boolean {
  const meta = parseMetadata(metadata);
  return meta.isSourceOfTruth === true;
}

async function setDocumentSourceOfTruthMetadata(docId: string, isSourceOfTruth: boolean): Promise<void> {
  const doc = await knowledgeBaseService.getKnowledgeBaseItem(docId);
  if (!doc) return;
  const meta = parseMetadata(doc.metadata);
  await knowledgeBaseService.updateKnowledgeBaseItem(docId, {
    metadata: {
      ...meta,
      isSourceOfTruth,
    },
  });
}

export async function toggleDocumentSourceOfTruth(docId: string): Promise<boolean> {
  const ids = await userProfileService.getSourceOfTruthDocIds();
  const isCurrently = ids.includes(docId);
  if (isCurrently) {
    await userProfileService.removeSourceOfTruthDocId(docId);
    await setDocumentSourceOfTruthMetadata(docId, false);
    queryClient.invalidateQueries({ queryKey: SOURCE_OF_TRUTH_QUERY_KEY });
    userProfileService.clearCache();
    return false;
  }
  await userProfileService.addSourceOfTruthDocId(docId);
  await setDocumentSourceOfTruthMetadata(docId, true);
  queryClient.invalidateQueries({ queryKey: SOURCE_OF_TRUTH_QUERY_KEY });
  userProfileService.clearCache();
  return true;
}

export async function removeDocumentFromSourceOfTruth(docId: string): Promise<void> {
  await userProfileService.removeSourceOfTruthDocId(docId);
  await setDocumentSourceOfTruthMetadata(docId, false);
  queryClient.invalidateQueries({ queryKey: SOURCE_OF_TRUTH_QUERY_KEY });
  userProfileService.clearCache();
}
